import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr1007',
    ecrans: ['00-2'],
    params: ['?coccleint']
});
